import React from "react";
import { ShimmerContentBlock } from "react-shimmer-effects";

const WorkshopShimmer = () => {
  return (
    <>
      <div className="mb_20">
        <ShimmerContentBlock
          title
          text
          cta
          thumbnailWidth={200}
          thumbnailHeight={200}
        />
      </div>
      <div className="mb_20">
        <ShimmerContentBlock
          title
          text
          cta
          thumbnailWidth={200}
          thumbnailHeight={200}
        />
      </div>
    </>
  );
};

export default WorkshopShimmer;
